/**
 * The tab values every tabbed route accepts, declared once.
 *
 * A route file cannot export these itself — anything but `Route` silently disables
 * `autoCodeSplitting` — so they live here, where the Zod search schema, the `Tabs` markup, the
 * loader's prefetch map and the notification action resolver all read the same tuple. A tab
 * renamed in one place then fails to compile in the others rather than quietly deep-linking
 * somewhere that no longer exists.
 */
export const ADMIN_SETTINGS_TABS = [
  'country-admin',
  'service-admin',
  'feature-admin',
  'pricing-admin',
] as const;

export type AdminSettingsTab = (typeof ADMIN_SETTINGS_TABS)[number];

export const SERVICES_TABS = ['services', 'features', 'carriage'] as const;

export type ServicesTab = (typeof SERVICES_TABS)[number];

export const BILLING_TABS = ['credit', 'receipts'] as const;

export type BillingTab = (typeof BILLING_TABS)[number];

export const WHOLESALER_SETTINGS_TABS = ['kyc', 'tcap-settings'] as const;

export type WholesalerSettingsTab = (typeof WHOLESALER_SETTINGS_TABS)[number];
